define('services/dataStore',[], function () {
    'use strict';

    /**
     * Data store implementation. Similar to the local storage
     * API, but has methods for handling specific data types
     * since localStorage only stores strings.
     *
     * Since local storage itself is not mockable this also
     * gives us an injectable storage module, and a point for
     * implementing cross-browser support if needed.
     * @exports services/dataStore
     */
    var dataStore = {
        setString: function (key, value) {
            localStorage.setItem(key, value);
        },
        getString: function (key) {
            return localStorage.getItem(key);
        },

        setObject: function (key, value) {
            return localStorage.setItem(key, JSON.stringify(value));
        },

        getObject: function (key) {
            var json = localStorage.getItem(key);
            return JSON.parse(json);
        },

        removeItem: function (key) {
            localStorage.removeItem(key);
        },
        clear: function () {
            localStorage.clear();
        }
    };

    return dataStore;
});

